<template>
	<pre v-html="$t('terms.agreement12')"></pre>
</template>

<script>
export default {
	name: 'Agreement12',
};
</script>

<style scoped></style>
